import { render, staticRenderFns } from "./px_index.vue?vue&type=template&id=0b9a374a&scoped=true"
import script from "./px_index.vue?vue&type=script&lang=js"
export * from "./px_index.vue?vue&type=script&lang=js"
import style0 from "./px_index.vue?vue&type=style&index=0&id=0b9a374a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9a374a",
  null
  
)

export default component.exports